import React from "react";
import { format } from "date-fns";

export interface FormatDateProps {
    dateString: string;
}

export const formattedDate = (formatNumber: string): string => {
    return format(new Date(formatNumber), "dd.MM.yyyy");
};

const FormatDate = React.forwardRef((props: FormatDateProps) => {
    return <>{formattedDate(props.dateString)}</>;
});

export default FormatDate;
